import dynamic from "next/dynamic";
import ImagesCarouselWithTagsGridAssetConfig from "./images-carousel-with-tags-grid-asset-config";
import ImagesCarouselWithTagsGridAssetAdvancedConfig from "./images-carousel-with-tags-grid-asset-advanced-config";
const ImagesCarouselWithTagsGridAssetComponent = dynamic(()=>import("./images-carousel-with-tags-grid-asset-component"));
export default {
    ImagesCarouselWithTagsGridAssetComponent,
    ImagesCarouselWithTagsGridAssetConfig,
    ImagesCarouselWithTagsGridAssetAdvancedConfig
};
